import "./style.css";

document.documentElement.classList.add("js");

const query = new URLSearchParams(window.location.search);
const qaReducedMotion = import.meta.env.DEV && query.has("qaReducedMotion");
if (qaReducedMotion) document.documentElement.classList.add("qa-reduced-motion");

const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches || qaReducedMotion;
const revealBlocks = [...document.querySelectorAll<HTMLElement>(".reveal-block")];

if (reducedMotion || !("IntersectionObserver" in window)) {
  revealBlocks.forEach((block) => block.classList.add("is-visible"));
} else {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-visible");
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.16, rootMargin: "0px 0px -6%" });
  revealBlocks.forEach((block) => revealObserver.observe(block));
}

type PreviewPerformance = { lcpMs: number | null; cls: number; maxInteractionMs: number };
const previewPerformance: PreviewPerformance = { lcpMs: null, cls: 0, maxInteractionMs: 0 };
Object.defineProperty(window, "__runsPreviewPerformance", { value: previewPerformance, configurable: true });
document.documentElement.dataset.cls = "0";
document.documentElement.dataset.maxInteractionMs = "0";

if ("PerformanceObserver" in window) {
  try {
    new PerformanceObserver((list) => {
      const latest = list.getEntries().at(-1);
      if (latest) {
        previewPerformance.lcpMs = latest.startTime;
        document.documentElement.dataset.lcpMs = latest.startTime.toFixed(1);
      }
    }).observe({ type: "largest-contentful-paint", buffered: true });
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const shift = entry as PerformanceEntry & { value?: number; hadRecentInput?: boolean };
        if (!shift.hadRecentInput) {
          previewPerformance.cls += shift.value ?? 0;
          document.documentElement.dataset.cls = previewPerformance.cls.toFixed(4);
        }
      });
    }).observe({ type: "layout-shift", buffered: true });
    new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        previewPerformance.maxInteractionMs = Math.max(previewPerformance.maxInteractionMs, entry.duration);
        document.documentElement.dataset.maxInteractionMs = previewPerformance.maxInteractionMs.toFixed(1);
      });
    }).observe({ type: "event", buffered: true, durationThreshold: 16 } as PerformanceObserverInit);
  } catch {
    // Older browsers keep the page fully usable; the QA packet records unavailable metrics.
  }
}
